class form{

	constructor() {
		

	}
	accessResearchEmbed(el) {
        $('.research-content button').on('click', function() {
            var data = {
                'action'              : 'access_research_embed',
                'name'                : $('input[name="name"]').val(),
                'email_address'       : $('input[name="email_address"]').val(),
                'research_id'         : $('input[name="research_id"]').val(),
                'research_title'      : $('input[name="research_title"]').val(),
                'research_link'       :$('input[name="research_link"]').val()
            };
            $.post( "/wp-admin/admin-ajax.php", data, function( response ) {
					
                if (response == 0) {
                    $('.error').show();
                }
                else {
                    console.log(response);
                    window.location = response;
                }

            });
        })
		
    }
    downloadResearch(el) {
        $('.form-download button').on('click', function() {
            var data = {
                'action'              : 'download_research',
                'first_name'          : $('input[name="first_name"]').val(),
                'last_name'           : $('input[name="last_name"]').val(),
                'email_address'       : $('input[name="email_address"]').val(),
                'company'             : $('input[name="company"]').val(),
                'title'               : $('input[name="title"]').val(),
                'phone_number'        : $('input[name="phone_number"]').val(),
                'current_arr'         : $('input[name="current_arr"]').val(),
                'research_id'         : $('input[name="research_id"]').val(),
                'research_title'      : $('input[name="research_title"]').val(),
            };
            $.post( "/wp-admin/admin-ajax.php", data, function( response ) {
                console.log(response);

                if (response == 0) {
                    $('.error').show();
                }
                else {
                    console.log(response);
                    window.location = response;
                }

            });
        })
		
	}
}
window.app.add('form', new form());